import {
  cryptoUint32,
  sample,
  type Uint32Source,
} from "@/lib/tool-kit/random-fun/rng";

/** The non-empty trimmed lines of the names box; a line's position is its identity. */
export function parseNameLines(text: string): string[] {
  return text
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
}

/** Every line number, in order: the starting pool. */
export function fullPool(lineCount: number): number[] {
  return Array.from({ length: lineCount }, (_, index) => index);
}

/**
 * Picks `count` different lines from the pool, uniformly. The pool holds line numbers,
 * not names, so two lines with the same text are two separate entries.
 */
export function pickLines(
  pool: readonly number[],
  count: number,
  source: Uint32Source = cryptoUint32
): number[] {
  return sample(pool, count, source);
}

/** The pool without the picked lines — by line number, so same-text lines stay. */
export function removeLines(
  pool: readonly number[],
  picked: readonly number[]
): number[] {
  const gone = new Set(picked);
  return pool.filter((line) => !gone.has(line));
}
